module.exports = __webpack_public_path__ + "static/img/clock__hand.2ce2b15.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/classroom/clock__hand.svg
// module id = 155
// module chunks = 0